import { render, staticRenderFns } from "./page-section.vue?vue&type=template&id=6a26b30b&scoped=true"
import script from "./page-section.vue?vue&type=script&lang=js"
export * from "./page-section.vue?vue&type=script&lang=js"
import style0 from "./page-section.vue?vue&type=style&index=0&id=6a26b30b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a26b30b",
  null
  
)

export default component.exports